// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Lessons from './pages/Lessons';
import CharactersList from './components/CharactersList';
import GamesList from './components/GamesList';
import WorldsList from './components/WorldsList';
import EnemiesList from './components/EnemiesList';
import About from './pages/About';
import { colors } from './styles/colors';

function App() {
  return (
    <Router>
      <div style={appContainer}>

        {/* Header / Navigation */}
        <header style={headerStyle}>
          <h1 style={titleStyle}>Mario Database – Learn SQL with Real Projects</h1>
          <nav style={navStyle}>
            <Link to="/" style={linkStyle}>Home</Link>
            <Link to="/lessons" style={linkStyle}>Lessons</Link>
            <Link to="/characters" style={linkStyle}>Characters</Link>
            <Link to="/games" style={linkStyle}>Games</Link>
            <Link to="/worlds" style={linkStyle}>Worlds</Link>
            <Link to="/enemies" style={linkStyle}>Enemies</Link>
            <Link to="/about" style={linkStyle}>About</Link>
          </nav>
        </header>

        {/* Main Content */}
        <main style={mainStyle}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/lessons" element={<Lessons />} />
            <Route path="/characters" element={<CharactersList />} />
            <Route path="/games" element={<GamesList />} />
            <Route path="/worlds" element={<WorldsList />} />
            <Route path="/enemies" element={<EnemiesList />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer style={footerStyle}>
          © 2026 Mario Database – perweb.site
        </footer>
      </div>
    </Router>
  );
}

// --- Styling ---
const appContainer = {
  fontFamily: "'Inter', sans-serif",
  background: colors.backgroundPage,
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
};

const headerStyle = {
  padding: '1rem 2rem',
  backgroundColor: colors.background,
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  borderBottomLeftRadius: '12px',
  borderBottomRightRadius: '12px',
};

const titleStyle = {
  margin: 0,
  color: colors.primary,
  fontSize: '1.5rem',
};

const navStyle = {
  marginTop: '0.5rem',
  display: 'flex',
  gap: '1rem',
  flexWrap: 'wrap',
};

const linkStyle = {
  textDecoration: 'none',
  color: colors.textLight,
  fontWeight: '500',
  transition: 'color 0.2s',
};

const mainStyle = {
  flex: 1,
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
};

const footerStyle = {
  padding: '1rem 2rem',
  textAlign: 'center',
  backgroundColor: colors.background,
  color: colors.text,
  fontWeight: '500',
  borderTopLeftRadius: '12px',
  borderTopRightRadius: '12px',
};

export default App;